// src/main.js
import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';

// Import Bootstrap JS
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import '@/assets/scss/main.scss';

// Create and mount the Vue application
const app = createApp(App);

// Register global components here if needed

// Use router and store
app.use(router);
app.use(store);

// Global error handler
app.config.errorHandler = (err, vm, info) => {
  console.error('Global error:', err);
  console.error('Vue component where error occurred:', vm);
  console.error('Vue info:', info);
};

// Mount the app
app.mount('#app');